import React, { useEffect, useState } from 'react'
import { db } from '../../firebase/index'
import { getPlumLinkReserveUrl } from '../utils/redirectToPlumLink'

const RedirectToReserve = ({ match }) => {
  const [message, setMessage] = useState('Web予約へ移動しています…')
  const id = match.params.id

  useEffect(() => {
    if (!id) {
      setMessage('アカウントが見つかりません')
      return
    }

    db.collection('accounts')
      .doc(id)
      .get()
      .then((res) => {
        const data = res.data()
        if (!data) {
          setMessage('アカウントが見つかりません')
          return
        }

        const reserveUrl = getPlumLinkReserveUrl(data.url)
        if (!reserveUrl) {
          setMessage('転送先を取得できませんでした')
          return
        }

        window.location.replace(reserveUrl)
      })
      .catch(() => {
        setMessage('転送に失敗しました')
      })
  }, [id])

  return <p style={{ padding: 24, textAlign: 'center' }}>{message}</p>
}

export default RedirectToReserve
